import { Component, OnInit } from '@angular/core';
import { MessageOptionsService } from 'src/app/services/message/message-options.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  expired = false;
  error = false;
  errorData=undefined;
  constructor(
    private messageOptions: MessageOptionsService
  ) {
    this.messageOptions.message$.pipe().subscribe(res =>{
      if(res){
        this.errors(res);
      }
    })
   }

  ngOnInit(): void {
  }

  errors(res){
    this.errorData=res;
    
    if(res['message'] === "Token invalid"){
      this.expired = true;
    }else{      
      if(res['error']['message'] === "Token invalid"){
        this.expired = true;
      }else{
        this.error = true;
      }
    }
  }

}
